export { default as SocialItem, socialItemColorVariants } from './Item.component'
